
export function set_barrios(state, barrios) {
        state.barrios = barrios

}
